import React from "react"
import { TestimonialCard } from "../ui/testimonial"
import { Testimonial } from "../../lib/testimonials"

interface FeaturedTestimonialsProps {
  testimonials: Testimonial[]
}

export function FeaturedTestimonials({ testimonials }: FeaturedTestimonialsProps) {
  return (
    <div className="grid gap-12 max-w-3xl mx-auto mb-16">
      {testimonials.map((testimonial) => (
        <TestimonialCard 
          key={testimonial.id}
          testimonial={testimonial}
          showViewMore={false}
          displayFull={true}
        />
      ))}
    </div>
  )
} 